import React from 'react';

import { MenuItem } from '@thinkific/chalk';
import { useSortable } from '@dnd-kit/sortable';
import { Space } from 'interfaces/space';
import { CSS } from '@dnd-kit/utilities';
import { DEFAULT_SPACE_ICON, SPACE_ICONS } from 'utils/constants';
import { useCommunityContext } from 'components/CommunityContext';
import { isAdmin } from 'utils/userHelpers';
import { LockSimple } from '@thinkific/chalk/react-icons';
import { pathnames } from 'utils/routerHelpers';
import { useRouter } from 'next/router';
import * as css from './SpacesItem.css';

interface SpacesItemProps {
  goToFunction: (filter: string, name: string) => void;
  space: Space;
}

export default function SpacesItem({ space, goToFunction }: SpacesItemProps) {
  const { currentUser } = useCommunityContext();
  const canSort = !isAdmin(currentUser);
  const router = useRouter();

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: space.id, disabled: canSort });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const iconToDisplay =
    SPACE_ICONS[space.iconName ? space.iconName : DEFAULT_SPACE_ICON];

  return (
    <div
      className={css.container}
      {...attributes}
      {...listeners}
      ref={setNodeRef}
      style={style}
    >
      <MenuItem
        active={
          router.pathname === pathnames.spaces.space &&
          router.query.spaceId === space.id
        }
        className={css.spaceItem}
        data-qa="space-item"
        icon={iconToDisplay}
        label={space.name}
        onClick={() => {
          goToFunction(space.id, space.name);
        }}
      >
        {space.name}
      </MenuItem>
      {space.isExclusive && <LockSimple size="sm" />}
    </div>
  );
}
